import { AppID } from '@playq/octopus-common';
import { AppEntityContentResponse } from '@playq/octopus2-apps';
import { GenericFailure } from '@playq/services-shared';
import { PermModule } from '@playq/octopus2-auth';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';
import { useModulePermissions } from '/hooks';

import { appConfigService } from './constants';

export const configRetrieveKeys: unknown[] = ['config', 'retrieve'];

export const useConfigRetrieve = (
  appID?: AppID,
  version?: number,
  options?: IUseQueryOptionsExtended<AppEntityContentResponse | undefined, GenericFailure | Error>
) => {
  const { canRead } = useModulePermissions(PermModule.Configuration);

  return useEitherQuery(
    configRetrieveKeys.concat(appID?.serialize(), version),
    () => appConfigService.retrieve(appID as AppID, version),
    {
      ...options,
      enabled: options?.enabled !== false && appID !== undefined && canRead,
    }
  );
};
